import type { ResourceListOptions } from '#dn-types/api.ts';
import type { CertificateAuthority } from '#dn-types/certificate-authority.ts';
import { getList } from './fetch.ts';

export const DEFAULT_CERTIFICATE_AUTHORITIES_PAGE_SIZE = 25;

// GET /certificate-authorities
export type GetCertificateAuthoritiesResult = CertificateAuthority[];
type GetCertificateAuthoritiesVariables = ResourceListOptions;
export function getCertificateAuthorities({
  cursor = '',
  pageSize = DEFAULT_CERTIFICATE_AUTHORITIES_PAGE_SIZE,
  init,
}: GetCertificateAuthoritiesVariables = {}) {
  return getList<GetCertificateAuthoritiesResult>(
    `/v1/certificate-authorities?includeCounts=true&cursor=${encodeURIComponent(cursor)}&pageSize=${pageSize}`,
    init
  ).then((res) => {
    // TODO: DRY this up with hosts
    const page = res.metadata.page;
    // If the user paginates backwards, we may send a cursor which results in loading the "first" page of results
    // but with fewer results than the standard page size. Refetch the first page without a cursor to get a full result set.
    if (page?.start === 0 && page.count < pageSize && cursor) {
      return getList<GetCertificateAuthoritiesResult>(
        `/v1/certificate-authorities?includeCounts=true&pageSize=${pageSize}`
      );
    }
    return res;
  });
}
